import React from "react";
import { object, bool, array } from "prop-types";
import { connect } from "react-redux";
import { SocialShare } from "@quintype/components";
import get from "lodash/get";
import CarouselCard from "../../molecules/story-card-5";
import Headline from "../../atoms/headline";
import HorizontalStoryCard from "../../molecules/horizontal-story-card";
import SpecialStoryHeader from "../../molecules/special-story-header";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import AuthorDetails from "../../molecules/author-details";
import StoryTags from "../story-tag";
import MetypeCommentWrapper from "../../metype-comments";
import StoryCard from "../story-card";
import DfpAd from "../../dfp-ad";
import fetchRelatedStories from "../../utils/fetch-related-stories";

import "./special-story.m.css";

export class SpecialStoryTemplate extends React.Component {
  state = {
    renderMetype: false,
    relatedStories: []
  };

  componentDidMount() {
    const { story } = this.props;
    const sectionId = get(story, ["sections", "0", "id"]);

    fetchRelatedStories(story.id, sectionId).then(relatedStories => {
      this.setState({ relatedStories });
    });

    this.setState({
      renderMetype: true
    });
  }

  render() {
    const { isBreakingNews } = this.props;
    const story = this.props.story;
    const sectionName = story.sections[0]["display-name"] || story.sections[0].name;
    const authorDetails = {
      name: get(story, ["authors", 0, "name"], story["author-name"]),
      id: story["author-id"],
      "twitter-handle": get(story, ["authors", 0, "twitter-handle"]),
      "avatar-url": get(story, ["authors", 0, "avatar-url"]),
      slug: get(story, ["authors", 0, "slug"]),
      "avatar-s3-key": get(story, ["authors", 0, "avatar-s3-key"])
    };

    return (
      <React.Fragment>
        <div styleName={`special-story ${isBreakingNews ? "" : "heading-top-margin"}`}>
          <div>
            <SpecialStoryHeader sectionName={sectionName} story={story} />
            <div styleName="story-body">
              <SocialShare
                template={StickySocialShareTemplate}
                title={story.headline}
                url={story.slug}
                color="#000"
                sticky
              />

              <div styleName="story-content">
                <AuthorDetails author={authorDetails} updatedOn={story["last-published-at"]} />
                {story.cards.map(card => (
                  <StoryCard key={card.id} card={card} story={story} />
                ))}
                <div styleName="ad-wrapper">
                  <DfpAd adtype="Banner_1" />
                </div>
                <div>
                  <StoryTags tags={story.tags} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop Design - Related Stories */}
        <div className="container" styleName="show-desktop">
          <Headline text="Related Stories" headerType={8} headerLevel={2} />
          <div styleName="related-story">
            {this.state.relatedStories.map((item, index) => {
              return (
                <CarouselCard
                  story={item}
                  headerLevel={4}
                  headerType={3}
                  imageType="image16x9"
                  sectionTitle
                  showPublishedTime
                  key={index}
                />
              );
            })}
          </div>
        </div>

        {/* Mobile Design - Related Stories */}
        <div className="container" styleName="show-mobile">
          <Headline text="Related Stories" headerType={8} headerLevel={2} />
          {this.state.relatedStories.map((item, index) => (
            <HorizontalStoryCard story={item} key={index} SectionName="Related Stories" />
          ))}
        </div>

        {/* MeType Integration */}
        <div styleName="metype-widget" className="container">
          {this.state.renderMetype && <MetypeCommentWrapper story={story} />}
        </div>
      </React.Fragment>
    );
  }
}

function SpecialStoryView(props) {
  const isBreakingNews = !!(props.breakingNewsLoaded && props.breakingNews.length !== 0);

  return (
    <div className="story-grid">
      <SpecialStoryTemplate story={props.story} collections={props.collections} isBreakingNews={isBreakingNews} />
    </div>
  );
}

function mapStateToProps(state) {
  const { breakingNews, breakingNewsLoaded } = state;

  return {
    breakingNews,
    breakingNewsLoaded
  };
}

SpecialStoryTemplate.propTypes = {
  story: object,
  metypeConfig: object,
  collections: object,
  isBreakingNews: bool
};

SpecialStoryView.propTypes = {
  story: object,
  collections: object,
  breakingNews: array,
  breakingNewsLoaded: bool
};

const SpecialStory = connect(mapStateToProps)(SpecialStoryView);

export default SpecialStory;
